import { connect } from 'react-redux'
import createPingAction from '../actions/ping'
import App from '../components/App'
import { getTitle, getContent } from '../reducers'

const mapStateToProps = state => {
  return {
    title: getTitle(state),
    content: getContent(state)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: {
    ping: () => dispatch(createPingAction())
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(App)


/** WEBPACK FOOTER **
 ** ./src/container/Main.js
 **/